<template>
  <TarjetaDatos titulo="Asegurados">
    <div v-for="ase in asegurados" :key="ase.numDoc">
      <Campo2L :valor="ase.nombreCompleto" />
    </div>
  </TarjetaDatos>
</template>
<script>
import emptyObj from "@/util/EmptyObject.js";
export default {
  props: {
    asegurados: {
      type: Array,
      required: false,
      default: emptyObj,
    },
  },
};
</script>

<style lang="scss" scoped></style>
